import { Save, X } from "lucide-react";
import { useState } from "react";

interface SectorFormProps {
  initial?: { name: string; relevance: string; notes: string };
  onSave: (data: { name: string; relevance: string; notes: string }) => void;
  onCancel: () => void;
  saving: boolean;
}

export function SectorForm({ initial, onSave, onCancel, saving }: SectorFormProps) {
  const [name, setName] = useState(initial?.name ?? "");
  const [relevance, setRelevance] = useState(initial?.relevance ?? "medium");
  const [notes, setNotes] = useState(initial?.notes ?? "");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    onSave({ name: name.trim(), relevance, notes });
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-end gap-2 rounded border border-border p-3">
      <div className="flex-1">
        <label className="block text-xs font-medium text-text-secondary">Sector Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="mt-1 w-full rounded border border-input-border bg-card px-2 py-1 text-sm text-text-primary focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
          placeholder="e.g. Financial Services"
        />
      </div>
      <div className="w-32">
        <label className="block text-xs font-medium text-text-secondary">Relevance</label>
        <select
          value={relevance}
          onChange={(e) => setRelevance(e.target.value)}
          className="mt-1 w-full rounded border border-input-border bg-card px-2 py-1 text-sm text-text-primary focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
        >
          <option value="high">High</option>
          <option value="medium">Medium</option>
          <option value="low">Low</option>
        </select>
      </div>
      <div className="flex-1">
        <label className="block text-xs font-medium text-text-secondary">Notes</label>
        <input
          type="text"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          className="mt-1 w-full rounded border border-input-border bg-card px-2 py-1 text-sm text-text-primary focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
          placeholder="Optional notes"
        />
      </div>
      <div className="flex gap-1">
        <button
          type="submit"
          disabled={saving || !name.trim()}
          className="rounded bg-accent p-1.5 text-white hover:bg-accent/90 disabled:opacity-50"
        >
          <Save size={14} />
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="rounded p-1.5 text-text-faint hover:bg-card-hover"
        >
          <X size={14} />
        </button>
      </div>
    </form>
  );
}
